import { Card, RealEstateObject, SearchResultPage } from '@immosky/types';

export interface SearchResultPageFactoryState {
  searchResultCards: Card<RealEstateObject>[];
  placeholderCards: Card[];
}

export class SearchResultPageFactory {
  private state: SearchResultPageFactoryState = {
    searchResultCards: [],
    placeholderCards: [],
  };

  get resultsPerPage() {
    return 24;
  }

  get placeholderIndices() {
    return [3, 10, 21, 24];
  }

  createPages(): SearchResultPage[] {
    const pages: SearchResultPage[] = [];
    const resultCardCount = this.state.searchResultCards.length;

    let resultCardIndex = 0;
    let placeholderCardIndex = 0;
    while (resultCardIndex < resultCardCount) {
      const cardsForPage = [];

      for (let i = 0; i < this.resultsPerPage; i++) {
        const hasAnotherPlaceholderCard =
          placeholderCardIndex < this.state.placeholderCards.length;
        const isPlaceholderSpot = this.placeholderIndices.indexOf(i) > -1;

        const shouldUseResultCard =
          !isPlaceholderSpot ||
          (isPlaceholderSpot && !hasAnotherPlaceholderCard);

        if (shouldUseResultCard) {
          cardsForPage.push(this.state.searchResultCards[resultCardIndex]);
          resultCardIndex++;

          if (resultCardIndex >= resultCardCount) {
            break;
          }
        } else if (hasAnotherPlaceholderCard) {
          cardsForPage.push(this.state.placeholderCards[placeholderCardIndex]);
          placeholderCardIndex++;
        } else {
          placeholderCardIndex = 0;
        }
      }

      placeholderCardIndex = 0;
      pages.push(new SearchResultPage(cardsForPage));
    }

    return pages;
  }

  setState(state: SearchResultPageFactoryState) {
    this.state = state;
  }
}
